module.exports = __webpack_public_path__ + "img/647.f5daf668.png";